import Panzoom from "@panzoom/panzoom";

export default class ImgZoom{

    constructor(element) {
        this.elWrapper = element;
        this.elMinus = this.elWrapper.querySelector('.js-img-zoom-minus');
        this.elPlus = this.elWrapper.querySelector('.js-img-zoom-plus');
        this.elRange = this.elWrapper.querySelector('.js-img-zoom-range');
        this.elImg = this.elWrapper.querySelector('.js-img-zoom-img');
        this.init();
        this.bindEvents()
    }

    bindEvents(){
        this.elPlus.addEventListener('click', () => {
            this.panzoom.zoomIn();
            this.elRange.value = this.panzoom.getScale() + '';
        });
        this.elMinus.addEventListener('click', () => {
            this.panzoom.zoomOut();
            this.elRange.value = this.panzoom.getScale() + '';
        });
        this.elRange.addEventListener('input', (event) => {
            this.panzoom.zoom(event.target.valueAsNumber)
        })
    }

    init(){
        this.panzoom = Panzoom(this.elImg, {
            minScale:1,
            maxScale: 5,
            step:0.1
        })
    }

}